export function inputanEmailCheck(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function inputanStringCheck(val) {
  switch (val) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
    default:
      return true;
  }
}

export function compareStringCheck(val1, val2) {
  switch (val2) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
  }
  return val1 == val2;
}

export function inputanIntCheck(val) {
  // console.log("val in", val);
  switch (val) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
    default:
      return !isNaN(val) && val != 0;
  }
}

export function inputanIntRangeCheck(val, start, end) {
  switch (val) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
  }
  if (start != null && start != undefined && end != null && end != undefined) {
    return val >= start && val <= end;
  }
  return false;
}

export function compareIntCheck(valStart, valEnd) {
  switch (valStart) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
  }
  switch (valEnd) {
    case undefined:
      return false;
    case null:
      return false;
    case "":
      return false;
  }
  return valStart <= valEnd;
}
